import { api } from 'shared/api'

import { systemKeywordsSchemas } from './schemas'

export const SystemKeywordsApi = {
  getSystemFlows: api.account.createPost({
    url: '/systemKeywords/getSystemFlows',
    schemas: systemKeywordsSchemas.getSystemFlows,
  }),
  getSubscribeFlow: api.account.createPost({
    url: '/systemKeywords/getSubscribeFlow',
    schemas: systemKeywordsSchemas.getSubscribeFlow,
  }),
  getUnsubscribeFlow: api.account.createPost({
    url: '/systemKeywords/getUnsubscribeFlow',
    schemas: systemKeywordsSchemas.getUnsubscribeFlow,
  }),
}
